import { useRootEditor } from 'sequential-workflow-designer-react';

export function ExternalRootEditor() {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const rootEditor = useRootEditor();

	return (
		<>
			<h2>Root editor</h2>

			<p>Please select any step...</p>
		</>
	);
}
